/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Head from "../Global/Head";
import Header from "../Global/Header";
import Footer from "../shared/footer/Footer";

const AboutUs = () => {
  return (
    <>
      <Head />
      <Header />
      <section class=" relative xl:mr-0 lg:mr-5 mr-0">
        <div class="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
          <div class="w-full justify-start items-center xl:gap-12 gap-10 grid lg:grid-cols-2 grid-cols-1">
            <div class="w-full flex-col justify-center lg:items-start items-center gap-10 inline-flex">
              <div class="w-full flex-col justify-center items-start gap-8 flex">
                <div class="flex-col justify-start lg:items-start items-center gap-4 flex">
                  <div class="w-full flex-col justify-start lg:items-start items-center gap-3 flex">
                    <h2 class="text-[#e2b760] text-4xl font-bold font-manrope leading-normal lg:text-start text-center">
                      About Us
                    </h2>
                    <p class="text-gray-500 text-base font-normal leading-relaxed lg:text-start text-center">
                      HighTable is a community where strangers meet offline in
                      small, intimate groups to spark genuine connections
                      through meaningful conversations. With no agendas or
                      pressure, it’s all about embracing real moments and the
                      joy of the unexpected. Whether it’s a lighthearted
                      exchange or a deep discussion, HighTable is where natural
                      connections come to life.
                    </p>
                  </div>
                </div>
              </div>
              <button class="sm:w-fit w-full group px-3.5 py-2 bg-[#e2b760] hover:bg-[#bc8f33] rounded-lg shadow-[0px_1px_2px_0px_rgba(16,_24,_40,_0.05)] transition-all duration-700 ease-in-out justify-center items-center flex">
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=support@hightable.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="px-1.5 text-white text-sm font-medium leading-6 group-hover:-translate-x-0.5 transition-all duration-700 ease-in-out">
                    Contact Us
                  </span>
                </a>

                <svg
                  class="group-hover:translate-x-0.5 transition-all duration-700 ease-in-out"
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M6.75265 4.49658L11.2528 8.99677L6.75 13.4996"
                    stroke="#fff"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div class="w-full lg:justify-start justify-center items-start flex">
              <div class="sm:w-[464px] w-full sm:h-[546px] h-full sm:bg-[#e0b867] rounded-3xl sm:border border-gray-200 relative">
                <img
                  class="sm:mt-5 sm:ml-5 w-full h-full rounded-3xl object-cover"
                  src="/images/about.jpg"
                  alt="about Us image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default AboutUs;
